export default "__VITE_ASSET__FFtLhvOr__"